module.exports = "/_next/static/images/icon_fb2-9056b1e4667ddae9033e6e17b7368aba.svg";